var $cd2b6c6859da6500$exports = {};
$cd2b6c6859da6500$exports = {
    "more": `\u{10E}al\u{161}ie polo\u{17E}ky`
};


export {$cd2b6c6859da6500$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
